<template>
    <div class="inner_box01">
        <div :class="['menu01', selectedTopTab.code === topTab.code ? 'on': 'off']"
            v-for="topTab in topTabs" :key="topTab.code">
            <a href="#" @click.prevent="selectTopTab(topTab.code, true)">
                {{ topTab.name }}{{ topTab.subName !== '' ? topTab.subName : '' }}
            </a>
        </div>

        <div :class="['menu01_s', selectedTopTab.code === topTab.code ? 'on': 'off']"
            v-for="topTab in topTabs" :key="'mid-tab-' + topTab.code">
            <ul class="scroll9">
                <li v-for="midTab in midTabs[topTab.code]" :key="midTab.code">
                    <input type="radio" :id="'mid-tab-' + midTab.code" name="midTab" class="leg_chk"
                        :checked="selectedMidTab.code === midTab.code ? 'checked' : ''"
                        @click="selectMidTab(midTab.code)">
                    <label :for="'mid-tab-' + midTab.code">&nbsp;</label>
                    <label :for="'mid-tab-' + midTab.code">{{ midTab.name }}</label>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'PopulationSelectPane',
    props: {
        initTopTabCode: {
            type: String,
            default: 'age',
            required: false,
        },
    },
    computed: {
        ...mapGetters({
            topTabs: 'getTopTabs',
            midTabs: 'getMidTabs',
            selectedTopTab: 'getSelectedTopTab',
            selectedMidTab: 'getSelectedMidTab',
        }),
    },
    created() {
        this.selectTopTab(this.initTopTabCode, true);
    },
    methods: {
        selectTopTab(selectedTopTabCode, midDefaultChecked) {
            let selectedTopTab = this.topTabs[selectedTopTabCode];
            this.$store.dispatch("SET_SELECTED_TOP_TAB", selectedTopTab);

            if(midDefaultChecked) {
                let subTabs = this.midTabs[selectedTopTabCode];
                for(let key in subTabs) {
                    this.selectMidTab(subTabs[key].code);
                    break;
                }
            }
        },
        selectMidTab(selectedMidTabCode) {
            let selectedMidTab = this.midTabs[this.selectedTopTab.code][selectedMidTabCode];
            this.$store.dispatch("SET_SELECTED_MID_TAB", selectedMidTab);
        },
    }
}
</script>
